import type { RootState } from '@/store';

export const selectNegociacaoIndividualWizard = (state: RootState) =>
  state.negociacaoIndividualWizard;

export const selectWizardAgents = (state: RootState) => state.negociacaoIndividualWizard.agents;
export const selectWizardAgentsLoading = (state: RootState) =>
  state.negociacaoIndividualWizard.isLoadingAgents;
export const selectWizardAgentDetailsLoading = (state: RootState) =>
  state.negociacaoIndividualWizard.isLoadingAgentDetails;
export const selectWizardAgentsError = (state: RootState) =>
  state.negociacaoIndividualWizard.agentsError;

export const selectWizardSelectedAgentId = (state: RootState) =>
  state.negociacaoIndividualWizard.selectedAgentId;
export const selectWizardSelectedAgent = (state: RootState) =>
  state.negociacaoIndividualWizard.selectedAgent;

export const selectWizardCounterparty = (state: RootState) =>
  state.negociacaoIndividualWizard.counterparty;

export const selectWizardDocValidation = (state: RootState) => ({
  isValidatingDoc: state.negociacaoIndividualWizard.isValidatingDoc,
  docLookupError: state.negociacaoIndividualWizard.docLookupError,
  docValidationData: state.negociacaoIndividualWizard.docValidationData,
});

export const selectWizardForm = (state: RootState) => ({
  title: state.negociacaoIndividualWizard.title,
  objective: state.negociacaoIndividualWizard.objective,
  claimAmount: state.negociacaoIndividualWizard.claimAmount,
  floorAmount: state.negociacaoIndividualWizard.floorAmount,
  marginPercent: state.negociacaoIndividualWizard.marginPercent,
  agentInput: state.negociacaoIndividualWizard.agentInput,
  extrajudicialItemId: state.negociacaoIndividualWizard.extrajudicialItemId,
});

export const selectWizardSchedule = (state: RootState) => ({
  startMode: state.negociacaoIndividualWizard.startMode,
  scheduledDate: state.negociacaoIndividualWizard.scheduledDate,
  scheduledTime: state.negociacaoIndividualWizard.scheduledTime,
});

export const selectWizardSubmit = (state: RootState) => ({
  isSubmitting: state.negociacaoIndividualWizard.isSubmitting,
  submitError: state.negociacaoIndividualWizard.submitError,
  created: state.negociacaoIndividualWizard.created,
});

export const selectWizardCancelStart = (state: RootState) => ({
  isCancellingStart: state.negociacaoIndividualWizard.isCancellingStart,
  cancelStartError: state.negociacaoIndividualWizard.cancelStartError,
});

export const selectWizardPhoneConflict = (state: RootState) =>
  state.negociacaoIndividualWizard.phoneConflict;

export const selectWizardPhoneConflictState = (state: RootState) => ({
  isValidatingPhoneConflict: state.negociacaoIndividualWizard.isValidatingPhoneConflict,
  phoneConflictError: state.negociacaoIndividualWizard.phoneConflictError,
  isClosingPhoneConflict: state.negociacaoIndividualWizard.isClosingPhoneConflict,
  closePhoneConflictError: state.negociacaoIndividualWizard.closePhoneConflictError,
});

export const selectWizardAgentsPagination = (state: RootState) =>
  state.negociacaoIndividualWizard.agentsPagination;
